module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_InvertedBadges_116x116_0-51d8990c4e985df1782687d1a7e3154d.png";